/* cr-scrub.js: scroll-scrubbed image sequence, drawn to a canvas.
   Portable like the other cr-* assets: everything is read from data attributes.

   <section data-scrub data-frames="94" data-src="frames/f{n}.webp" data-pad="3">
     <div class="scrub__stage"><canvas class="scrub__canvas"></canvas> ...overlays </div>
   </section>

   Or list the frames instead of a pattern, for hosts that version each file
   (Shopify's asset_url adds a different ?v= per asset):
     <script type="application/json" data-scrub-frames>["url1","url2",...]</script>
   inside the section; data-frames and data-src are then not needed.

   Overlays carry data-scrub-range="from,to" (0..1 of the scroll) and get
   .is-on while the progress is inside it. The section also gets --p (0..1), and the root --scrub-p.

   Why a canvas and not <video>: seeking a video on scroll lags 50-150ms and is
   least reliable on iOS Safari, where most of this store's traffic is. Drawing
   a decoded frame is synchronous. */
(function () {
  function pad(n, w) { n = String(n); while (n.length < w) n = '0' + n; return n; }

  function init(sec) {
    if (!sec.querySelector('canvas')) return;
    var list = null, listEl = sec.querySelector('script[data-scrub-frames]');
    if (listEl) { try { list = JSON.parse(listEl.textContent); } catch (e) { list = null; } }
    var count = list ? list.length : parseInt(sec.getAttribute('data-frames'), 10);
    var tpl = sec.getAttribute('data-src');
    var w = parseInt(sec.getAttribute('data-pad') || '0', 10);
    var canvas = sec.querySelector('canvas');
    var ctx = canvas.getContext('2d');
    var overlays = sec.querySelectorAll('[data-scrub-range]');
    var frames = new Array(count);
    var current = -1, ticking = false;

    function url(i) { return list ? list[i] : tpl.replace('{n}', pad(i + 1, w)); }

    function load(i) {
      return new Promise(function (res) {
        var img = new Image();
        img.decoding = 'async';
        img.onload = function () { frames[i] = img; res(); };
        img.onerror = function () { res(); };
        img.src = url(i);
      });
    }

    // nearest frame already loaded at or before i, so a fast scroll on a slow
    // connection shows an earlier frame instead of nothing
    function nearest(i) {
      for (var j = i; j >= 0; j--) if (frames[j]) return frames[j];
      for (j = i + 1; j < count; j++) if (frames[j]) return frames[j];
      return null;
    }

    function size() {
      var r = canvas.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(r.width * dpr);
      canvas.height = Math.round(r.height * dpr);
      current = -1;
      draw();
    }

    function progress() {
      var r = sec.getBoundingClientRect();
      var travel = sec.offsetHeight - window.innerHeight;
      if (travel <= 0) return 0;
      return Math.min(1, Math.max(0, -r.top / travel));
    }

    function draw() {
      ticking = false;
      var p = progress();
      sec.style.setProperty('--p', p.toFixed(4));
      // also on the root, so a progress rule outside the section can read it
      document.documentElement.style.setProperty('--scrub-p', p.toFixed(4));
      for (var k = 0; k < overlays.length; k++) {
        var rg = overlays[k].getAttribute('data-scrub-range').split(',');
        var on = p >= parseFloat(rg[0]) && p <= parseFloat(rg[1]);
        overlays[k].classList.toggle('is-on', on);
      }
      var i = Math.min(count - 1, Math.round(p * (count - 1)));
      var img = nearest(i);
      if (!img || (i === current && frames[i])) return;
      current = frames[i] ? i : -1;
      var cw = canvas.width, ch = canvas.height, iw = img.naturalWidth, ih = img.naturalHeight;
      // portrait screens cover (fill the phone); wide screens fit the height,
      // and the frame's pure black ground meets the stage's black at the edges
      var s = cw / ch < 0.8 ? Math.max(cw / iw, ch / ih) : ch / ih;
      var dw = iw * s, dh = ih * s;
      ctx.fillStyle = '#000';
      ctx.fillRect(0, 0, cw, ch);
      ctx.drawImage(img, (cw - dw) / 2, (ch - dh) / 2, dw, dh);
    }

    function request() { if (!ticking) { ticking = true; requestAnimationFrame(draw); } }

    // first frame first, then the rest in order, a few at a time
    load(0).then(function () {
      size();
      var next = 1, running = 0;
      function pump() {
        while (running < 6 && next < count) {
          running++;
          load(next++).then(function () { running--; request(); pump(); });
        }
      }
      pump();
    });

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', size);
    sec.classList.add('is-ready');
  }

  function boot() {
    // reduced motion keeps the poster and loads no frames
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var all = document.querySelectorAll('[data-scrub]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
